import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import mixins from './mixins';
/* INSTALADOS */
import axios from 'axios';
//import AOS from 'aos';
/* INSTALADOS */

Vue.config.productionTip = false
window.baseUrl  = process.env.VUE_APP_ROOT_API;
window.tokenAPI = process.env.VUE_APP_TOKEN_API;//Para mi token API
window.baseHost = window.baseUrl.substr(0,window.baseUrl.indexOf('index.php'));
window.baseCli  = process.env.VUE_APP_ROOT_CLI;
const instance  = axios.create({
  baseURL: window.baseUrl,
  headers: {
    'Authorization': 'Bearer '+window.tokenAPI,
    'X-API-KEY': window.tokenAPI, //Esto solo es para la version de codeigniter
    'Content-type':'json',
  }
});


window.$ = window.jQuery = require('jquery');//Esto es cuando se instala desde consola
window.fn = require('./static/owl.carousel/owl.carousel.min.js');
window.Popper = require('popper.js').default;
require('bootstrap');

require('./static/jquery-sticky/jquery.sticky');
require('./static/counterup/counterup.min');
require('./static/venobox/venobox.min');
require('./static/isotope-layout/isotope.pkgd.min');

require('./static/main');
Vue.mixin(mixins);
Vue.prototype.$http=instance;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
